export const styles = {
  content: 'p-lg md:p-2xl gap-md md:gap-lg ',
  actions: 'w-full sm:flex-row-reverse',
  secondaryBtn: 'sm:flex-0',
  primaryBtn: 'sm:flex-1',
  text: 'text-center',
};
